import { ResourceBookingFlowEnum } from "@/common/enums";
import { LicenseType } from "@/common/enums";

export class ResourceTypeHelpers {
    static CalculateBookingFlow(licenseType: LicenseType, isHotDesk: boolean): ResourceBookingFlowEnum {
        if (licenseType === LicenseType.Workspace) {
            return ResourceBookingFlowEnum.Workspace;
        }
        if (isHotDesk) {
            return ResourceBookingFlowEnum.HotDesk;
        }
        return ResourceBookingFlowEnum.Standard;
    }
} 